import { render, staticRenderFns } from "./gitlab_version_check_badge.vue.js?vue&type=template&id=1d0ddf36!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./gitlab_version_check_badge.vue?vue&type=template&id=1d0ddf36"
import script from "./gitlab_version_check_badge.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./gitlab_version_check_badge.vue?vue&type=script&lang=js"
export * from "./gitlab_version_check_badge.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./gitlab_version_check_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d0ddf36')) {
      api.createRecord('1d0ddf36', component.options)
    } else {
      api.reload('1d0ddf36', component.options)
    }
    module.hot.accept("./gitlab_version_check_badge.vue.js?vue&type=template&id=1d0ddf36!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./gitlab_version_check_badge.vue?vue&type=template&id=1d0ddf36", function () {
      api.rerender('1d0ddf36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "gitlab_version_check/components/gitlab_version_check_badge.vue"
export default component.exports